import { t } from "@lingui/core/macro";

import { Button } from "@whoosh/design-system/src/components/controls/Button/Button";
import {
  ArrowLeftIcon,
  CloseIcon,
} from "@whoosh/design-system/src/components/icons_v2/general";
import { HStack, Text } from "@whoosh/design-system/src/components/primitive";

type RewardsModalHeaderProps = {
  onClose: () => void;
};

export const RewardsModalHeader = ({ onClose }: RewardsModalHeaderProps) => (
  <HStack alignItems="center" gap={3} width="100%" pb={4}>
    <Button
      size="regular"
      accessibilityLabel={t`Close Rewards modal`}
      testID="loyalty-rewards-close-button"
      variant="secondary"
      onPress={onClose}
      leftIcon={<CloseIcon />}
    />
    <Text variant="mainTitle2" color="text-primary">
      {t`Rewards`}
    </Text>
  </HStack>
);

type RewardsModalBackHeaderProps = {
  onBack: () => void;
  accessibilityLabel?: string;
  testID?: string;
  title?: string;
};

export const RewardsModalBackHeader = ({
  onBack,
  accessibilityLabel,
  testID = "loyalty-rewards-back-button",
  title,
}: RewardsModalBackHeaderProps) => (
  <HStack alignItems="center" gap={3} width="100%" pb={4}>
    <Button
      size="regular"
      accessibilityLabel={accessibilityLabel ?? t`Back to available rewards`}
      testID={testID}
      variant="secondary"
      onPress={onBack}
      leftIcon={<ArrowLeftIcon />}
    />
    <Text variant="mainTitle2" color="text-primary">
      {title ?? t`Rewards`}
    </Text>
  </HStack>
);
